import {createSelector} from "reselect"
import {CONFIG} from "../../config"

export const getIntl = (state, props) => props.intl // eslint-disable-line
export const getIntlLocale = state => state.intl.locale
export const getLangs = () => CONFIG.intl.langs

export const getOtherLocales = createSelector([getIntlLocale], intlLocale => CONFIG.intl.langs.filter(lang => lang != intlLocale))
